import { useAppDispatch, useAppSelector } from "../../../../redux/store";

import { Box, Typography } from "@mui/material";

import {
  Button,
  ChipGroup,
  ChipMultiGroup,
  Input,
  PageHeader,
  Toolbar,
} from "../../../../ui";

import { addUser, changeFilter, clearFilters } from "../usersSlice";

const UsersTableControls = () => {
  const dispatch = useAppDispatch();
  const filters = useAppSelector((state) => state.users.filters);

  const handleStatusFilter = (newStatus: string) => {
    dispatch(changeFilter({ name: "status", value: newStatus }));
  };

  const handleRoleFilter = (roles: string[]) => {
    dispatch(changeFilter({ name: "role", value: roles }));
  };

  const handleClearFilters = () => {
    dispatch(clearFilters());
  };

  return (
    <>
      <PageHeader
        eyebrow="Administration"
        title="Users"
        summary="Everyone who can sign in to the portal, and what they can reach."
        actions={
          <Button onClick={() => dispatch(addUser())}>Add new user</Button>
        }
      />
      <Toolbar>
        <ChipGroup
          value={typeof filters.status === "string" ? filters.status : "all"}
          onChange={handleStatusFilter}
          size="sm"
          options={[
            ["all", "All"],
            ["active", "Active"],
            ["inactive", "Inactive"],
            ["deleted", "Deleted"],
            ["pendingActivation", "Pending"],
          ]}
        />
        <ChipMultiGroup
          values={filters.role || []}
          onChange={handleRoleFilter}
          size="sm"
          options={[
            ["admin", "Admin"],
            ["employee", "Employee"],
            ["client", "Client"],
          ]}
        />
        <Button variant="ghost" size="sm" onClick={handleClearFilters}>
          Clear
        </Button>
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, ml: "auto" }}>
          <Typography
            sx={{
              fontSize: 10,
              fontWeight: 700,
              letterSpacing: "0.12em",
              textTransform: "uppercase",
              color: "var(--tpc-600)",
            }}
          >
            Created
          </Typography>
          <Input
            type="date"
            aria-label="Created from"
            value={filters.createdFrom || ""}
            max={filters.createdTo || undefined}
            onChange={(event) =>
              dispatch(
                changeFilter({ name: "createdFrom", value: event.target.value }),
              )
            }
            style={{ width: 145 }}
          />
          <Typography sx={{ fontSize: 12, color: "var(--tpc-600)" }}>
            to
          </Typography>
          <Input
            type="date"
            aria-label="Created to"
            value={filters.createdTo || ""}
            min={filters.createdFrom || undefined}
            onChange={(event) =>
              dispatch(
                changeFilter({ name: "createdTo", value: event.target.value }),
              )
            }
            style={{ width: 145 }}
          />
        </Box>
      </Toolbar>
    </>
  );
};

export default UsersTableControls;
